export interface ConvocatoriasBEPSModel {
  nombre_convocatoria: string;
  area: Array<any>;
  entidad: string;
  cobertura: string;
  descripcion_corta: string;
  perfil_participante: string;
  tipo_participante: Array<any>;
  tipo: number;
  fechas: Array<any>;
  documentos: Array<any>;
  portada_url?:string
}

export const initialValuesConvocatoriasBEPSModel = {
  nombre_convocatoria: "",
  area: [],
  entidad: "",
  cobertura: "",
  descripcion_corta: "",
  perfil_participante: "",
  fechas: [],
  documentos: [],
  tipo_participante: [],
  tipo: 0,
  portada_url:""
};

export interface ConvocatoriasFechasBEPSModel {
  fecha_apertura: string;
  fecha_cierre: string;
  fecha_informeinscritos: string;
  fecha_subsanacion: string;
  fecha_finalinscritos: string;
}

export const initialValuesConvocatoriasFechasBEPSModel = {
  fecha_apertura: "",
  fecha_cierre: "",
  fecha_informeinscritos: "",
  fecha_subsanacion: "",
  fecha_finalinscritos: "",
}